import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  viewLiveButton: {
    id: 'course-authoring.course-unit.button.view-live',
    defaultMessage: 'View live version',
    description: 'The unit view live button text',
  },
  previewButton: {
    id: 'course-authoring.course-unit.button.preview',
    defaultMessage: 'Preview',
    description: 'The unit preview button text',
  },
  editButton: {
    id: 'course-authoring.course-unit.button.edit',
    defaultMessage: 'Edit',
    description: 'The unit edit button text',
  },
});

export default messages;
